"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperationTransformation = exports.getOperationInputSlugs = exports.taskFromOperationNode = exports.taskToOperationNode = exports.operationConvertors = void 0;
const common_1 = require("@finley-technologies/common");
const converter_1 = require("./operations/ai2csv/converter");
const converter_2 = require("./operations/asset2json/converter");
const converter_3 = require("./operations/attachHeader/converter");
const converter_4 = require("./operations/edit/converter");
const converter_5 = require("./operations/filter/converter");
const converter_6 = require("./operations/flatten/converter");
const converter_7 = require("./operations/join/converter");
const converter_8 = require("./operations/pdf2csv/converter");
const converter_9 = require("./operations/preFilter/converter");
const converter_10 = require("./operations/pyCsvVirtualSheet/converter");
const converter_11 = require("./operations/pyXlsx2csv2/converter");
const converter_12 = require("./operations/pyXlsxVirtualSheet2Csv/converter");
const converter_13 = require("./operations/sanitize/converter");
const converter_14 = require("./operations/stack/converter");
const converter_15 = require("./operations/unzip/converter");
const converter_16 = require("./operations/xlsx2csv/converter");
const converter_17 = require("./operations/xlsx2csv2/converter");
// Constrains keys to valid operations while inferring the exact registered set.
// Typing the registry as an exhaustive `Record<Operation, ...>` makes a missing
// operation convertor a COMPILE error (rather than a runtime `.find` miss), and
// a misspelled key a compile error too. (`satisfies` is unavailable under the
// repo's pinned prettier 2.2.1.)
const asOperationRegistry = (registry) => registry;
exports.operationConvertors = asOperationRegistry({
    ai2Csv: converter_1.convertor,
    asset2json: converter_2.convertor,
    attachHeader: converter_3.convertor,
    edit: converter_4.convertor,
    filter: converter_5.convertor,
    flatten: converter_6.convertor,
    join: converter_7.convertor,
    pdf2csv: converter_8.convertor,
    preFilter: converter_9.convertor,
    sanitize: converter_13.convertor,
    xlsx2csv: converter_16.convertor,
    xlsx2csv2: converter_17.convertor,
    pyXlsx2Csv2: converter_11.convertor,
    pyXlsxVirtualSheet2Csv: converter_12.convertor,
    pyCsvVirtualSheet: converter_10.convertor,
    unzip: converter_15.convertor,
    stack: converter_14.convertor,
});
// Guard against key/value drift: each entry's own `operation` must equal the
// key it is registered under (the value type is widened, so this can't be
// enforced by the type system).
Object.entries(exports.operationConvertors).forEach(([key, converter]) => {
    (0, common_1.finleyAssert)(converter.operation === key, `operationConvertors misregistered: key "${key}" holds convertor for "${converter.operation}"`);
});
const operationConvertorArray = Object.values(exports.operationConvertors);
const getConvertorByOperation = (operation) => exports.operationConvertors[operation];
const getConvertorByNodeType = (nodeType) => {
    const converter = operationConvertorArray.find((con) => con.nodeType === nodeType);
    (0, common_1.finleyAssert)(converter, `no converter found for nodeType: ${nodeType}`);
    return converter;
};
const taskToOperationNode = ({ task, }) => {
    const converter = getConvertorByOperation(task.operation);
    return converter.taskToOperationNode(task);
};
exports.taskToOperationNode = taskToOperationNode;
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const converter = getConvertorByNodeType(operationNode.metadata.tapeBuilderNodeType);
    return converter.taskFromOperationNode({ srcNodes, operationNode });
};
exports.taskFromOperationNode = taskFromOperationNode;
/**
 * The input artifact slugs whose buffers an operation needs at execution time.
 * Delegates to the operation's own `getInputSlugs` when defined, else defaults
 * to `[task.srcArtifactSlug]`. Single source of truth for operation input
 * topology (previously an inline switch in `tapeBuilder.ts`).
 */
const getOperationInputSlugs = (task) => {
    const converter = getConvertorByOperation(task.operation);
    return converter.getInputSlugs
        ? converter.getInputSlugs(task)
        : [task.srcArtifactSlug];
};
exports.getOperationInputSlugs = getOperationInputSlugs;
/**
 * Builds the tape-sanitizer Transformation for a task by delegating to the
 * operation's own `toTransformation`. Single dispatch point replacing the
 * `convertTransformationOperation` switch that used to live in tapeBuilder.ts.
 */
const getOperationTransformation = (task, resolveDef) => {
    const converter = getConvertorByOperation(task.operation);
    return converter.toTransformation(task, resolveDef);
};
exports.getOperationTransformation = getOperationTransformation;
//# sourceMappingURL=operationConvertors.js.map